import { useCreateFieldGetter, usePageBodyStyle } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for Help page body background customisation.
 * Returns content style for the scrollable body container.
 */
export const useHelpBodyBackgroundCustomisation = () => {
  return usePageBodyStyle({
    registryId: PUI.REGISTRY_IDS.HELP_PAGE,
    sectionKey: PUI.HELP_SECTION_KEYS.BODY_BACKGROUND,
    blockKey: PUI.HELP_BLOCK_KEYS.BODY_SECTION,
  });
};

/**
 * Composable for Help page body title customisation (e.g. Self Service section title).
 * Returns text content, text color and visibility for the body section title.
 */
export const useHelpBodyTitleCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.HELP_PAGE,
    sectionKey: PUI.HELP_SECTION_KEYS.BODY_TITLE,
    blockKey: PUI.HELP_BLOCK_KEYS.BODY_SECTION,
  });

  const textContent = getField(PUI.COMMON_FIELD_KEYS.TEXT_CONTENT);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);

  return {
    isVisible,
    textContent,
    textColor,
  };
};
